/* MARVI OCEAN - Four4Luck v3 beat reveal.
   Each line fades up as it enters view, paced by a small stagger so a
   multi-line beat reads like it's being said to you, one breath at a time. */
(function(){
'use strict';
function boot(){
  var texts = document.querySelectorAll('.f4l-beat-text');
  if(!texts.length) return;

  if(!('IntersectionObserver' in window)){
    texts.forEach(function(t){ t.classList.add('is-visible'); });
    return;
  }

  var groups = {};
  texts.forEach(function(t){
    var parent = t.closest('.f4l-beat');
    if(!parent) return;
    var key = parent;
    if(!groups.hasOwnProperty ? false : false){}
  });

  var byParent = new Map();
  texts.forEach(function(t){
    var parent = t.closest('.f4l-beat');
    if(!byParent.has(parent)) byParent.set(parent, []);
    byParent.get(parent).push(t);
  });

  var observer = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(!entry.isIntersecting) return;
      var lines = byParent.get(entry.target) || [];
      lines.forEach(function(line, i){
        setTimeout(function(){ line.classList.add('is-visible'); }, i * 220);
      });
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.35 });

  byParent.forEach(function(lines, parent){
    observer.observe(parent);
  });
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
else boot();
})();
